/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { modelKeysDeleteKey } from "../funcs/modelKeysDeleteKey.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteModelProviderKeyRequest,
  DeleteModelProviderKeySecurity,
} from "../models/operations/deletemodelproviderkey.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteModelProviderKeyMutationVariables = {
  request: DeleteModelProviderKeyRequest;
  security?: DeleteModelProviderKeySecurity | undefined;
  options?: RequestOptions;
};

export type DeleteModelProviderKeyMutationData = void;

export type DeleteModelProviderKeyMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteKey modelKeys
 *
 * @remarks
 * Delete a model provider key. Completions on the affected slot fall back to the project default key or the platform key.
 */
export function useDeleteModelProviderKeyMutation(
  options?: MutationHookOptions<
    DeleteModelProviderKeyMutationData,
    DeleteModelProviderKeyMutationError,
    DeleteModelProviderKeyMutationVariables
  >,
): UseMutationResult<
  DeleteModelProviderKeyMutationData,
  DeleteModelProviderKeyMutationError,
  DeleteModelProviderKeyMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteModelProviderKeyMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteModelProviderKey(): MutationKey {
  return ["@gram/client", "modelKeys", "deleteKey"];
}

export function buildDeleteModelProviderKeyMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteModelProviderKeyMutationVariables,
  ) => Promise<DeleteModelProviderKeyMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteModelProviderKey(),
    mutationFn: function deleteModelProviderKeyMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteModelProviderKeyMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(modelKeysDeleteKey(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
